import { render, staticRenderFns } from "./OActiveRoute.vue?vue&type=template&id=e8ab83b6&"
import script from "./OActiveRoute.vue?vue&type=script&lang=js&"
export * from "./OActiveRoute.vue?vue&type=script&lang=js&"
import style0 from "./OActiveRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports